import { FC } from 'react';
import Lottie from 'react-lottie';
import { Line } from 'react-chartjs-2';
import Icon, { IconNames } from 'components/Icon';
import colors from 'constants/colors';
import { numberWithDot, sumAmounts } from 'helpers/utils';
import { ITrendDonationData } from 'store/donation/types';
import { chartInitialValues } from 'constants/chart';
import * as chartSkeletonAnimation from '../../assets/json/chart-skeleton.json';

const skeletonOptions = {
  loop: true,
  autoplay: true,
  animationData: chartSkeletonAnimation,
  rendererSettings: { preserveAspectRatio: 'xMidYMid meet' },
};

interface Props {
  isLoading: boolean;
  donationTrend: ITrendDonationData[];
  chartData: typeof chartInitialValues;
}

export const GivingActivityChart: FC<Props> = ({ isLoading, donationTrend, chartData }) => {
  if (isLoading) {
    return <Lottie options={skeletonOptions} />;
  }

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-row">
          <Icon name={IconNames.MoneyBill} color={colors.inkBlue} size={20} />
          <span className="oath-body inkBlue">Recent Giving Activity</span>
        </div>
        <span className="oath-h3 inkBlue">
          ${' '}
          {numberWithDot(
            sumAmounts(donationTrend?.map(item => parseFloat(item.amount)))?.toFixed(2)
          )}
        </span>
      </div>
      <div className="card-body">
        {chartData.data.datasets[0].data.length > 0 && (
          <Line data={chartData.data} options={chartData.options} height={380} width={826} redraw />
        )}
      </div>
    </div>
  );
};
